import { render, staticRenderFns } from "./ItemDashboard.vue?vue&type=template&id=7198e624&"
import script from "./ItemDashboard.vue?vue&type=script&lang=js&"
export * from "./ItemDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports